module.exports = __webpack_public_path__ + "img/checklist.d2952c17.svg";